export const getMockData = (key: string) => localStorage.getItem(key);

export const getMockListData =
  <T>(key: string) =>
  (): T =>
    JSON.parse(getMockData(key) || '[]');

export const getMockListDataAsync =
  <T>(key: string) =>
  async (): Promise<T> =>
    JSON.parse(getMockData(key) || '[]');